/**
 * Configuração de uma season: nome e duração em dias — o mesmo desenho do
 * "configurar duração" da timeline do Roadmap, incluindo o piso vindo do servidor
 * quando alguém tenta encolher para menos do que o calendário ocupa.
 */
import { useState } from 'react';

import type { Season } from './calendarioTipos';

export function ConfigurarSeason({
  season,
  podeExcluir,
  salvando,
  erro,
  aoSalvar,
  aoExcluir,
  aoFechar,
}: {
  season: Season;
  /** Falso quando é a única season do projeto — a tela sempre precisa de uma. */
  podeExcluir: boolean;
  salvando: boolean;
  erro: string | null;
  aoSalvar(mudancas: { nome?: string; diasTotal?: number }): void;
  aoExcluir(): void;
  aoFechar(): void;
}) {
  const [nome, setNome] = useState(season.nome);
  const [dias, setDias] = useState(season.diasTotal);

  return (
    <div className="cal-config">
      <div className="ff">
        <label>Nome da season</label>
        <input value={nome} onChange={(e) => setNome(e.target.value)} />
      </div>
      <div className="ff">
        <label>Duração (dias)</label>
        <input
          type="number"
          min={1}
          max={120}
          value={dias}
          onChange={(e) => setDias(Number(e.target.value))}
          style={{ width: 90, textAlign: 'center', fontWeight: 600 }}
        />
      </div>
      <button
        className="mu-btn"
        disabled={salvando || !nome.trim() || dias < 1 || dias > 120}
        onClick={() => aoSalvar({ nome: nome.trim(), diasTotal: dias })}
      >
        {salvando ? 'Salvando…' : 'Salvar'}
      </button>
      <button className="mu-btn ghost" onClick={aoFechar}>
        Cancelar
      </button>
      {podeExcluir && (
        <button className="cal-excluir" onClick={aoExcluir} title="Excluir esta season">
          Excluir season
        </button>
      )}
      {erro && <div className="cal-erro">{erro}</div>}
    </div>
  );
}
